import { FC } from 'react'
import { ActionItemStyled } from './style'
import { Tag } from '@gate/gui'
import useLangPrefix from '@/hooks/useLangPrefix'
import { useAdapter } from '@/components/Adapter'
import { stopEvent } from '@/utils/tools'

interface IActionItem {
  value: string
  link: string
  label: string
  title?: string
  tag?: string
  type?: string
}

interface ActionItemProps {
  list: IActionItem[]
  handleClick?: (curItem?: IActionItem) => void
}

const ActionItem: FC<ActionItemProps> = ({ list, handleClick }) => {
  const { langPrefix } = useLangPrefix()
  const { isH5 } = useAdapter()

  return (
    <ActionItemStyled>
      {list.map(item => (
        <a
          className={`price-table-action--item price-table-action--item-${item?.tag ? 'tag' : ''}`}
          key={item?.link}
          href={langPrefix + item?.link}
          title={item?.title}
          onClick={e => {
            stopEvent(e)
            handleClick && handleClick(item)
            if (isH5) {
              location.href = langPrefix + item?.link
            } else {
              window.open(langPrefix + item?.link, '_blank')
            }
          }}
        >
          <span className="label">{item?.label}</span>

          {item?.tag && (
            <div className="right">
              <Tag bg="var(--color-cmpt-11)" label={item?.tag} />
            </div>
          )}
        </a>
      ))}
    </ActionItemStyled>
  )
}

export default ActionItem
